import getConfig from 'next/config';
import jsCookie from 'js-cookie';
import { sha256 } from 'js-sha256';
import { HTTPClient } from '../api';

const { BASE_URL_MEDIA } = getConfig().publicRuntimeConfig;

export const sendToFacebookConversion = async (leadID, data) => {
  const date = new Date();
  const timestampInSeconds = Math.floor(date.getTime() / 1000);
  const payload = {
    data: [
      {
        event_name: 'Lead',
        event_time: timestampInSeconds,
        event_id: leadID,
        user_data: {
          em: [data.email ? sha256(data.email) : ''],
          ph: [data.phoneNumber ? sha256(data.phoneNumber) : ''],
          fbc: jsCookie.get('__fbc'),
          fbp: jsCookie.get('__fbp'),
          subscription_id: leadID,
        },
        custom_data: {
          content_category: data.brand ?? '',
          content_name: data.model ?? '',
          predicted_ltv: 6.36,
          currency: 'usd',
          value: 6.36,
        },
        event_source_url: window.location.pathname,
        action_source: 'website',
      },
    ],
  };
  const request = {
    method: 'POST',
    body: JSON.stringify(payload),
  };

  return await HTTPClient(`${BASE_URL_MEDIA}api/external/facebook-conversion/`, request);
};
